import { PlanDetail, SubscribePlan } from '../../../../types';
import { PaymentUpdateStatusType } from '../../subscription';
import { SubscriptionPeriod } from '../types';

export type PlanCompleteView = {
  /** 소문자 정규화된 플랜 타입. 값이 없으면 빈 문자열(크래시 방어). */
  plan: SubscribePlan;
  /** 문자열 maxCcu. 값이 없으면 빈 문자열. */
  maxCcu: string;
  subscriptionPeriod: SubscriptionPeriod;
};

/**
 * 완료 페이지 URL 쿼리로 넘어오는 변경 대상 플랜 정보.
 * (moveCompletePage가 체크아웃 쿼리를 그대로 이어받아 실어준다)
 */
export type DowngradeQuery = {
  planType?: string;
  maxCcu?: string;
  subscriptionPeriod?: string;
};

/**
 * 플랜 결제/변경 완료 화면의 표시값을 파생한다.
 *
 * DOWN_GRADE(예약 변경)의 표시값은 **URL 쿼리를 우선** 사용한다. 서버의
 * `subscriptionInfo.nextSpacePlanTemplate`는 subscribe 직후 전파 지연으로
 * 비어 올 수 있어(그 값을 그대로 dereference하면 크래시) 신뢰할 수 없기 때문.
 * 쿼리는 결제 플로우가 완료 URL에 직접 실어주므로 즉시·안정적으로 존재한다.
 * 쿼리가 없으면 API 값 → 빈 문자열 순으로 폴백해 어떤 경우에도 크래시하지 않는다.
 */
export const derivePlanCompleteView = (
  planDetailData: PlanDetail | undefined,
  updateStatus: PaymentUpdateStatusType,
  downgradeQuery: DowngradeQuery = {},
): PlanCompleteView => {
  const isDowngrade = updateStatus === 'DOWN_GRADE';
  const nextTemplate = planDetailData?.subscriptionInfo?.nextSpacePlanTemplate;

  const maxCcu = String(
    (isDowngrade
      ? downgradeQuery.maxCcu ?? nextTemplate?.maxCcu
      : planDetailData?.spacePlan?.maxCcu) ?? '',
  );
  const plan = (
    (isDowngrade
      ? downgradeQuery.planType || nextTemplate?.planType
      : planDetailData?.spacePlan?.planType) || ''
  ).toLowerCase() as SubscribePlan;
  const subscriptionPeriod = String(
    (isDowngrade
      ? downgradeQuery.subscriptionPeriod ?? nextTemplate?.subscriptionPeriod
      : planDetailData?.subscriptionInfo?.subscription?.subscriptionPeriod) ??
      '',
  ) as SubscriptionPeriod;

  return { plan, maxCcu, subscriptionPeriod };
};
